var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { useNavigate } from '../../hooks';
import { Card } from '@amzn/atoz-web/Card';
import { Text } from '@amzn/atoz-web/Text';
import { styledWithTheme } from '@amzn/atoz-web/Theme';
import { Button, ButtonVariant } from '@amzn/atoz-web/Button';
import { Routes } from '@amzn/atoz-shiftapp-initializer';
import { dateParam, refParam, findShiftsRefValue } from '../../config/queryParams';
import { useTranslation } from 'react-i18next';
export var NoShiftsForDay = function (_a) {
    var selectedDate = _a.selectedDate;
    var navigate = useNavigate();
    var t = useTranslation().t;
    var handleClick = function () {
        navigate("".concat(Routes.FindShifts, "?").concat(dateParam, "=").concat(selectedDate.toISODate(), "&").concat(refParam, "=").concat(findShiftsRefValue));
    };
    return (React.createElement(StyledCard, { dataTestId: "NoShiftsForDay", role: "listitem" },
        React.createElement(Text, null, t('shift_management_features_NoShiftsForDay_descriptionText')),
        React.createElement(Button, { dataTestId: "NoShiftsForDay_Button", variant: ButtonVariant.Primary, onClick: handleClick }, t('shift_management_features_NoShiftsForDay_buttonText'))));
};
var StyledCard = styledWithTheme(Card)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    border: none;\n    display: flex;\n    justify-content: space-between\n"], ["\n    border: none;\n    display: flex;\n    justify-content: space-between\n"])));
var templateObject_1;
